"use client";
import { Box, Container, SxProps, Theme, Typography, useMediaQuery } from "@mui/material";
import * as React from "react";

import Image from "next/image";

const CruisePromoDealsHero: React.FC<{
  title: string;
  subTitle?: string;
  mobileTitle: string;
  imageSrc: string;
  imageAlt: string;
  sx?: SxProps<Theme>;
}> = ({ title, subTitle, mobileTitle, imageSrc, imageAlt, sx }) => {
  const isMobile = useMediaQuery("(max-width: 600px)");

  return (
    <Box
      sx={{
        mt: { xs: "0rem", sm: "1rem", md: "1rem", lg: "2.5rem", xl: "3rem" },
        mb: { xs: "0px", md: "0rem" },
        ...sx,
      }}
    >
      <Container
        sx={{
          "@media screen and (max-width:600px)": {
            px: "0px",
            mx: "0px",
            maxWidth: "100%",
          },
          position: "relative",
        }}
      >
        <Box
          sx={{
            position: { xs: "absolute", md: "absolute" },
            top: { xs: "2rem", md: "5rem" },
            left: { xs: "50%", md: "50%" },
            transform: { xs: "translate(-50%)", md: "translate(-50%)" },
            width: "100%",
            pt: { xs: "8px", md: "10px" },
          }}
        >
          {isMobile ? (
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: "2rem", sm: "2rem", md: "2.5rem", lg: "2.5rem" },
                color: "#5900FF",
                fontWeight: { xs: 700, md: 600 },
                textAlign: "center",
                lineHeight: 1.15,
                mb: { xs: "4px", md: "16px" },
                px: { xs: "16px", md: "0px" },
                textShadow: {
                  xs: "2px 2px 2px #fff, 2px 2px 2px #fff",
                  md: "2px 2px 0px #fff",
                },
                display: { xs: "block", md: "none" },
              }}
            >
              <Box component="span">{mobileTitle}</Box>
            </Typography>
          ) : (
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: "2rem", sm: "2rem", md: "2.5rem", lg: "2.5rem" },
                color: "#5900FF",
                fontWeight: { xs: 700, md: 600 },
                textAlign: "center",
                lineHeight: 1.15,
                mb: { xs: "4px", md: "16px" },
                px: { xs: "16px", md: "0px" },
                textShadow: {
                  xs: "2px 2px 2px #fff, 2px 2px 2px #fff",
                  md: "2px 2px 0px #fff",
                },
                display: { xs: "none", md: "block" },
              }}
            >
              {title}
            </Typography>
          )}
       {subTitle  &&  <Typography
            variant="body2"
            sx={{
              fontSize: { xs: "14px", sm: "15px", md: "1rem" },
              color: "#000",
              mb: { xs: "12px", md: "1rem" },
              textAlign: "center",
              width: "100%",
              // "@media screen and (max-width:900px)": {
              display: { xs: "grid", md: "block" },
              placeItems: "center",
              fontFamily: "'blauerNue', 'blauerNue Fallback'",
              fontWeight: 700,
              span: {
                p: "4px 10px",
                mt: "4px",
                backdropFilter: "blur(5px)",
                bgcolor: "#fff",
                width: "fit-content",
                borderRadius: "10px",
              },
              // },
            }}
          >
            <Box component="span">{subTitle}</Box>
          </Typography>}
        </Box>

        <Box
          sx={{
            height: { xs: "180px", sm: "280px", md: "40vh" },
            minHeight: { xs: "150px", md: "400px" },
            width: "100%",
            img: {
              height: "100%",
              width: "100%",
              objectFit: "cover",
              border: { xs: "none", sm: "2px solid #5D04D9", md: "3px solid #fff" },
              borderBottom: {
                xs: "5px solid #5D04D9",
                sm: "2px solid #5D04D9",
                md: "3px solid #fff",
              },
              boxShadow: { xs: "unset", md: "0px 0px 10px rgba(0,0,0,0.2)" },
              borderRadius: { xs: "0px", sm: "15px", md: "20px" },
              overflow: "hidden",
            },
          }}
        >
          <Image
            src={imageSrc}
            width={1000}
            height={600}
            loader={({ src }) => src}
            alt={imageAlt}
            priority
          />
        </Box>
      </Container>
    </Box>
  );
};

export default CruisePromoDealsHero;
